<script setup>
	
</script>

<template>
	<div id="filigraneWrapper">
		<div id="filigrane">
			Acceptance
		</div>
	</div>
</template>

<style scoped>
	#filigraneWrapper {

		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		pointer-events: none;
		z-index: 9000;

		#filigrane {
			position: fixed;
			top: 50%;
			left: 50%;
			translate: -50% -50%;
			font-size: 15vw;
			font-weight: bold;
			rotate: -15deg;
			background: #ffffff2a;
			color: #00000019;
			padding: 0.5em 10em;
		}
	}
</style>